import { MouseEventHandler, ReactNode } from "react";

export default function Button({
  children,
  size = "md",
  className = "btn btn-primary",
  onClick,

  disabled = false,
}: {
  children?: ReactNode;
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  size?: "sm" | "md" | "lg";
}) {
  return (
    <button
      disabled={disabled}
      className={`${className} ${
        size === "md" ? "" : size === "sm" ? "btn-sm text-sm" : "btn-lg"
      } `}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
